/**
 * Ayuda — Administración → Compras → Proveedores
 * (Misma pantalla de entidades que Clientes, con rol proveedor.)
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PUR_ENTITIES_ITEM = {
  id: 'entities',
  screenId: 'adm-pur-entities',
  label: 'Proveedores',
  description: 'Ver, buscar y cargar proveedores.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá administrás a las empresas o personas de las que comprás. La pantalla funciona igual que Clientes en Ventas, pero orientada a proveedores.',
      },
      {
        title: 'Paso 1 — Ver el listado',
        intro: 'La lista muestra nombre, nombre fantasía, tipo y número de documento, y un ícono para editar.',
        paragraphs: [
          'Tocá una fila para consultar la ficha del proveedor.',
          'Tocá el lápiz para modificar los datos.',
        ],
      },
      {
        title: 'Paso 2 — Buscar',
        intro: 'Escribí al menos 3 letras del nombre en «Buscar Proveedores». Si borrás el texto, vuelve la lista completa.',
      },
      {
        title: 'Paso 3 — Cargar un proveedor nuevo',
        intro:
          'El botón + abre «Agregar nuevo». El formulario es el mismo que para clientes: datos principales, direcciones, teléfonos, mails, ubicación fiscal, lista de precios, cuenta corriente, grupos e información bancaria. Desde Compras, la opción «Proveedor» viene marcada; podés marcar también «Cliente» si la misma persona es las dos cosas.',
      },
      {
        title: 'Campos principales del alta',
        fields: [
          { label: 'Tipo y número de identificación', description: 'CUIT, DNI, etc. Con CUIT o DNI el sistema puede traer datos de AFIP.' },
          { label: 'Razón social', description: 'Nombre legal. Obligatorio.' },
          { label: 'Nombre de fantasía', description: 'Nombre comercial. Opcional.' },
          { label: 'Condición frente al IVA', description: 'Define cómo se registran las compras y facturas.' },
          { label: 'Cliente / Proveedor', description: 'Desde Compras, «Proveedor» viene activado.' },
          { label: 'Cuenta corriente proveedor', description: 'Si comprás a crédito, podés activar cuenta corriente, límite y moneda.' },
        ],
        paragraphs: [
          'Tocá «Crear entidad» para guardar.',
        ],
      },
    ],
  },
}
